const Chevron = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icons - Arrows 32px">
        <g id="Group">
          <path
            id="Vector"
            d="M21.5 12.5L15.5 18.5L9.5 12.5"
            stroke="#4A4D4E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default Chevron;
